// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2FhQM","options":"AnswerScale_options__38JA8","selected":"AnswerScale_selected__2t6fm"};